export default "__VITE_ASSET__DFs8A8Gc__"